var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["facebook-feed", "facebook-feed--" + this.profile] },
    [
      _vm._t("header"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "facebook-feed__items" },
        [
          _vm._l(_vm.filteredData, function(item, index) {
            return index < _vm.pageLoads * _vm.count
              ? _vm._t(
                  "feed",
                  [
                    _c(
                      "div",
                      {
                        key: index,
                        staticClass: "facebook-feed__item",
                        class: _vm.itemClass(item.type)
                      },
                      [
                        _c(
                          "a",
                          { attrs: { href: item.link, target: "_blank" } },
                          [
                            _c("div", {
                              staticClass: "image-container",
                              style: _vm.imageStyle(item.full_picture)
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _vm.displayDescription
                          ? _c("div", { staticClass: "content-container" }, [
                              item.message
                                ? _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("truncate")(item.message, 90)
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.link
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "btn read-more",
                                      attrs: {
                                        target: "_blank",
                                        href: item.link
                                      }
                                    },
                                    [_vm._v("Read More")]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    )
                  ],
                  { index: index, item: item }
                )
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.moreData && _vm.displayLoadMore
        ? _c("div", { staticClass: "load-more-wrapper" }, [
            _c(
              "button",
              {
                staticClass: "load-more",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.loadMore()
                  }
                }
              },
              [_vm._v("Load More")]
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib?{}!./scripts/vue/FacebookFeed.vue?vue&type=template&id=2661b238&
// module id = 130
// module chunks = 7